import React from "react";
import PropTypes from "prop-types";
var clickedAnswerIndex = null;
var updateClickedAnswer = function updateClickedAnswer(index) {
  clickedAnswerIndex = index;
};
var addClass = function addClass(wasClicked, clickedAnswer, shouldTriggerPoints, index) {
  if (!wasClicked) {
    return;
  }
  if (shouldTriggerPoints) {
    return "correct-answer";
  } else if (clickedAnswer === index && !shouldTriggerPoints) {
    return "wrong-answer";
  }
  return "inactive";
};
var StepAnswers = function StepAnswers(_ref) {
  var content = _ref.content,
    wasClicked = _ref.wasClicked,
    points = _ref.points,
    onUpdatePoints = _ref.onUpdatePoints,
    updatePoints = _ref.updatePoints;
  return /*#__PURE__*/React.createElement("div", {
    className: "step__answers-container"
  }, content.ResponseOptions.map(function (responseOption, index) {
    return /*#__PURE__*/React.createElement("button", {
      className: "step-button ".concat(addClass(wasClicked, clickedAnswerIndex, responseOption.TriggerPoints, index))
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: index,
      onClick: function onClick(e) {
        e.preventDefault();
        updatePoints(responseOption.TriggerPoints);
        onUpdatePoints({
          points: points
        }, responseOption.TriggerPoints);
        updateClickedAnswer(index);
      },
      disabled: wasClicked
    }, /*#__PURE__*/React.createElement("span", {
      className: "checkmark"
    }), /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: responseOption.Label
      }
    }));
  }));
};
export default StepAnswers;
StepAnswers.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  wasClicked: PropTypes.bool.isRequired,
  points: PropTypes.number.isRequired,
  onUpdatePoints: PropTypes.func.isRequired,
  updatePoints: PropTypes.func.isRequired
};